/* Hanger Uniforms — global theme JS */
(function () {
  'use strict';

  /* ---- Mobile nav ----
     Full-screen dialog: aria-expanded synced on the toggle, body scroll
     locked while open, Escape / link tap / close button / resize past the
     breakpoint all close it, focus moves in on open and back on close. */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    var close = nav.querySelector('[data-menu-close]');
    var desktop = window.matchMedia('(min-width: 991px)');
    var isOpen = false;

    function focusables() {
      return nav.querySelectorAll('a[href], button:not([disabled])');
    }
    function open() {
      if (isOpen) return;
      isOpen = true;
      nav.hidden = false;
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.documentElement.classList.add('is-menu-open');
      document.body.style.overflow = 'hidden';
      if (close) close.focus();
    }
    function shut(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      nav.classList.remove('is-open');
      nav.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.documentElement.classList.remove('is-menu-open');
      document.body.style.overflow = '';
      if (returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function () { isOpen ? shut(true) : open(); });
    if (close) close.addEventListener('click', function () { shut(true); });
    nav.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) shut(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); shut(true); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var onWide = function (e) { if (e.matches) shut(false); };
    if (desktop.addEventListener) desktop.addEventListener('change', onWide);
    else if (desktop.addListener) desktop.addListener(onWide);
  }

  /* ---- Product gallery thumbnails ---- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Quantity steppers ---- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var val = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change'));
        });
      });
    });
  }

  /* ---- File upload zones (quote / product / upload page) ---- */
  function initFileDrop() {
    document.querySelectorAll('[data-file-drop]').forEach(function (drop) {
      var input = drop.querySelector('input[type="file"]');
      var names = drop.querySelector('[data-file-names]');
      if (!input) return;
      function show() {
        if (!names) return;
        if (input.files.length) {
          var list = [];
          for (var i = 0; i < input.files.length; i++) list.push(input.files[i].name);
          names.textContent = list.join(', ');
        } else { names.textContent = ''; }
      }
      drop.addEventListener('click', function (e) { if (e.target !== input) input.click(); });
      input.addEventListener('change', show);
      ['dragover', 'dragenter'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) { input.files = e.dataTransfer.files; show(); }
      });
    });
  }

  /* ---- Number inputs: select-on-focus + strip leading zeros -----
     Typing "4" after a default "0" can otherwise leave "04" showing,
     since the browser treats it as inserted text rather than replacing
     the placeholder digit. */
  function initNumberInputs() {
    document.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('focus', function () { input.select(); });
      input.addEventListener('input', function () {
        if (input.value.length > 1) {
          input.value = input.value.replace(/^0+(?=\d)/, '');
        }
      });
      // Typing a value below the field's minimum (e.g. a product's minimum
      // order quantity) only gets caught by the browser on form submit —
      // clamp on blur too so the visible number is never misleadingly low.
      input.addEventListener('blur', function () {
        var min = parseInt(input.min, 10);
        if (!isNaN(min) && (parseInt(input.value, 10) || 0) < min) {
          input.value = min;
          input.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  /* ---- Sticky header shadow ---- */
  function initHeaderShadow() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 4px 20px rgba(15,42,74,0.08)' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initProductGallery();
    initQty();
    initFileDrop();
    initNumberInputs();
    initHeaderShadow();
  });
})();
